    const ACESSORIOS = [
        ' ', '-', '_', '\\t', '\\r', '\\n', '\\/',
        '\\(', '\\)', '\\[', '\\]', '\\{', '\\}'
    ];

    const tirarAcessorios = texto => {
        if(!texto) {
            return '';
        }
        if(typeof texto !== 'string') {
            return undefined;
        }
        let textoLimpo = texto;
        ACESSORIOS.forEach(caracter => {
            const regex = new RegExp(caracter, 'g');
            textoLimpo = textoLimpo.replace(regex,'');
        });
        return textoLimpo;
    }

    const tirarAcentos = texto => {
        return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }

    const padronizarTextos = texto => {
        const textoSemAcessorios = tirarAcessorios(texto);
        const textoEmMinusculas = String(textoSemAcessorios).toLowerCase();
        return tirarAcentos(textoEmMinusculas);
    }

    export function testarSemelhantes(padrao:string, teste:string) {
        if(padrao===teste) {
            return false;
        }
        const strPadrao = padronizarTextos(padrao);
        const strTeste = padronizarTextos(teste);
        return strPadrao===strTeste;
    }

    export function pegarSemelhante(colecao:Array<string>, padrao:string) {
        for (const teste of colecao) {
            if(testarSemelhantes(padrao, teste))
                return teste;
            }
        return '';
    }

    export function textoSimilar(atual:string, novo:string,
        cadastrados:Array<string>):string {
        if(!atual) {
            atual = '';
        }
        const novoVazio = !novo;
        const iguais = (atual === novo);
        if ( novoVazio || iguais ) {
            return '';
        }
        return pegarSemelhante(cadastrados, novo);
    }


